import { useState, useEffect, useRef } from "react";
import Dropdown from "./Dropdown";
import DropdownFilter from "./DropdownFilter";
import InputData from "./InputData";
import InputDataControl from "../support-extra/components/InputDataControl";
import CheckBox from "./CheckBox";
import ButtonIconV from "./ButtonIconV";
import CanvasDraw from "react-canvas-draw";
import ButtonIconH from "./ButtonIconH";
import TooltipBox from "./Tooltip";
import LoadingScreen from "./LoadingScreen";
import {
  inputOnEnter,
  basicOptometry,
  selectedOptic,
  userData,
  CORRECCIONLIST,
  BASELIST,
  previousRXData,
  areObjectsEqual,
  focusElement,
  calculateAddFromTotal,
  calculateTotalLens,
  calculateTransposition,
  validateOptometryData,
} from "../js/utils";
import { post } from "../js/post";
import "../css/BasicOptometry.css";
import moment from "moment";
import { useOptometrists } from "../hooks/useOptometrists";
import { useOphtalmologists } from "../hooks/useOphtalmologists";
import { BasicOptometryReportPopup } from "./BasicOptometryReportPopup";
import PopupCGCOOOftalmica from "../support-extra/components/PopupCGCOOOftalmica";

export default function BasicOptometry(props) {
  const [selectedDate, setSelectedDate] = useState({
    id: "",
    text: "",
    type: "",
  });
  const [currentBasicOptometry, setCurrentBasicOptometry] =
    useState(basicOptometry);
  const [currentBasicOptometryEdit, setCurrentBasicOptometryEdit] =
    useState(basicOptometry);
  const [optometryDateHistoryList, setOptometryDateHistoryList] = useState([]);
  const [previousRX, setPreviousRX] = useState(previousRXData);
  const optometristList = [{ id: "", text: "" }, ...useOptometrists()];
  const ophthalmologistList = [
    { id: "", text: "" },
    ...useOphtalmologists().map((e) => ({ id: e.text, text: e.text })),
  ];
  const [optometryId, setOptometryId] = useState(props.optometryId);
  const canvasRef = useRef(null);
  const [loadingData, setLoadingData] = useState(false);
  const [reportPopup, setReportPopup] = useState(false);
  const [CGCOOPopup, setCGCOOPopup] = useState(false);

  // console.log("currentBasicOptometryEdit: ", currentBasicOptometryEdit);

  const getOptometryDateHistoryList = async () => {
    const response = await post("ListarFechasHistoricoOptometriaBasica.php", {
      token: userData.token,
      idPaciente: props.patientId,
      optica: selectedOptic.id,
    });
    if (response.length > 0) {
      const found = response.find((e) => {
        return e.idOptometria === parseInt(optometryId);
      });
      if (found) {
        setSelectedDate({
          id: found.idOptometria,
          text: found.fecha,
          type: found.tipo,
        });
      }
    }
    setOptometryDateHistoryList(response);
  };

  const getBasicOptometry = async (optometryId) => {
    const response = await post("ObtenerOptometriaBasica.php", {
      token: userData.token,
      optica: selectedOptic.id,
      idOptometria: optometryId,
    });
    setCurrentBasicOptometryEdit({
      ...response,
      idPaciente: props.patientId,
      idOptometria: optometryId,
    });
    setCurrentBasicOptometry({
      ...response,
      idPaciente: props.patientId,
      idOptometria: optometryId,
    });
    if (canvasRef.current) {
      canvasRef.current.loadSaveData(JSON.stringify(response.esquema));
    }
  };

  const getPreviousRX = async () => {
    const response = await post("ObtenerRXAnterior.php", {
      token: userData.token,
      optica: selectedOptic.id,
      idPaciente: props.patientId,
      fecha: selectedDate.text,
      tipo: currentBasicOptometryEdit.tipo,
    });
    // console.log(
      // "OBTENIENDO RX ANTERIOR: ",
      // {
        // token: userData.token,
        // optica: selectedOptic.id,
        // idPaciente: props.patientId,
        // fecha: selectedDate.text,
        // tipo: currentBasicOptometryEdit.tipo,
      // },
      // response,
    // );
    if (response !== "") {
      setPreviousRX(response);
    } else {
      setPreviousRX(previousRXData);
    }
  };

  const getPreviousBasicOptometryData = async () => {
    const response = await post("ObtenerDatosOptometriaBasicaAnterior.php", {
      token: userData.token,
      optica: selectedOptic.id,
      idPaciente: props.patientId,
      fecha: moment().format("YYYY-MM-DD HH:mm:ss"),
      tipo: currentBasicOptometryEdit.tipo,
    });
    // console.log(
      // "OBTENIENDO OPTOMETRIA BASICA ANTERIOR: ",
      // {
        // token: userData.token,
        // optica: selectedOptic.id,
        // idPaciente: props.patientId,
        // fecha: moment().format("YYYY-MM-DD HH:mm:ss"),
        // tipo: currentBasicOptometryEdit.tipo,
      // },
      // response,
    // );
    if (response !== "") {
      setCurrentBasicOptometryEdit((prev) => ({
        ...basicOptometry,
        av_sc_lejos_d: response.av_sc_lejos_d,
        av_sc_lejos_i: response.av_sc_lejos_i,
        av_sc_lejos: response.av_sc_lejos,
        av_sc_cerca_d: response.av_sc_cerca_d,
        av_sc_cerca_i: response.av_sc_cerca_i,
        av_sc_cerca: response.av_sc_cerca,
        av_cc_lejos_d: response.av_cc_lejos_d,
        av_cc_lejos_i: response.av_cc_lejos_i,
        av_cc_lejos: response.av_cc_lejos,
        av_cc_cerca_d: response.av_cc_cerca_d,
        av_cc_cerca_i: response.av_cc_cerca_i,
        av_cc_cerca: response.av_cc_cerca,
        nasopupilar_lejos_d: response.nasopupilar_lejos_d,
        nasopupilar_lejos_i: response.nasopupilar_lejos_i,
        interpupilar_lejos: response.interpupilar_lejos,
        nasopupilar_cerca_d: response.nasopupilar_cerca_d,
        nasopupilar_cerca_i: response.nasopupilar_cerca_i,
        interpupilar_cerca: response.interpupilar_cerca,
        pio_d: response.pio_d,
        pio_i: response.pio_i,
        h_od_dp: response.h_od_dp,
        h_od_mm: response.h_od_mm,
        ejedh: response.ejedh,
        v_od_dp: response.v_od_dp,
        v_od_mm: response.v_od_mm,
        ejedv: response.ejedv,
        h_oi_dp: response.h_oi_dp,
        h_oi_mm: response.h_oi_mm,
        ejeih: response.ejeih,
        v_oi_dp: response.v_oi_dp,
        v_oi_mm: response.v_oi_mm,
        ejeiv: response.ejeiv,
        tipo: prev.tipo,
      }));
      setCurrentBasicOptometry((prev) => ({
        ...basicOptometry,
        av_sc_lejos_d: response.av_sc_lejos_d,
        av_sc_lejos_i: response.av_sc_lejos_i,
        av_sc_lejos: response.av_sc_lejos,
        av_sc_cerca_d: response.av_sc_cerca_d,
        av_sc_cerca_i: response.av_sc_cerca_i,
        av_sc_cerca: response.av_sc_cerca,
        av_cc_lejos_d: response.av_cc_lejos_d,
        av_cc_lejos_i: response.av_cc_lejos_i,
        av_cc_lejos: response.av_cc_lejos,
        av_cc_cerca_d: response.av_cc_cerca_d,
        av_cc_cerca_i: response.av_cc_cerca_i,
        av_cc_cerca: response.av_cc_cerca,
        nasopupilar_lejos_d: response.nasopupilar_lejos_d,
        nasopupilar_lejos_i: response.nasopupilar_lejos_i,
        interpupilar_lejos: response.interpupilar_lejos,
        nasopupilar_cerca_d: response.nasopupilar_cerca_d,
        nasopupilar_cerca_i: response.nasopupilar_cerca_i,
        interpupilar_cerca: response.interpupilar_cerca,
        pio_d: response.pio_d,
        pio_i: response.pio_i,
        h_od_dp: response.h_od_dp,
        h_od_mm: response.h_od_mm,
        ejedh: response.ejedh,
        v_od_dp: response.v_od_dp,
        v_od_mm: response.v_od_mm,
        ejedv: response.ejedv,
        h_oi_dp: response.h_oi_dp,
        h_oi_mm: response.h_oi_mm,
        ejeih: response.ejeih,
        v_oi_dp: response.v_oi_dp,
        v_oi_mm: response.v_oi_mm,
        ejeiv: response.ejeih,
        tipo: prev.tipo,
      }));
    }
  };

  const copyToNewOptometry = () => {
    setCurrentBasicOptometryEdit({
      ...currentBasicOptometryEdit,
      esfera_d: previousRX.esfera_d,
      esfera_i: previousRX.esfera_i,
      cilindro_d: previousRX.cilindro_d,
      cilindro_i: previousRX.cilindro_i,
      eje_d: previousRX.eje_d,
      eje_i: previousRX.eje_i,
      adicion_d: previousRX.adicion_d,
      adicion_i: previousRX.adicion_i,
      intermedia_d: previousRX.intermedia_d,
      intermedia_i: previousRX.intermedia_i,
      cerca_d: previousRX.cerca_d,
      cerca_i: previousRX.cerca_i,
      total_d: previousRX.total_d,
      total_i: previousRX.total_i,
    });
  };

  const saveBasicOptometry = async () => {
    const response = await post("GuardarOptometriaBasica.php", {
      token: userData.token,
      optica: selectedOptic.id,
      idOptometria: optometryId,
      idPaciente: props.patientId,
      ...currentBasicOptometryEdit,
      pio_hora:
        currentBasicOptometryEdit.pio_d === "" &&
        currentBasicOptometryEdit.pio_i === ""
          ? ""
          : currentBasicOptometryEdit.pio_hora,
      fecha_actualizacion: moment().format("YYYY-MM-DD HH:mm:ss"),
    });
    // console.log(
      // "GUARDANDO OPTOMETRÍA: ",
      // {
        // token: userData.token,
        // optica: selectedOptic.id,
        // idOptometria: optometryId,
        // idPaciente: props.patientId,
        // ...currentBasicOptometryEdit,
        // pio_hora:
          // currentBasicOptometryEdit.pio_d === "" &&
          // currentBasicOptometryEdit.pio_i === ""
            // ? ""
            // : currentBasicOptometryEdit.pio_hora,
        // fecha_actualizacion: moment().format("YYYY-MM-DD HH:mm:ss"),
      // },
      // response,
    // );
    // Actualizamos la fecha_actualizacion
    setCurrentBasicOptometryEdit({
      ...currentBasicOptometryEdit,
      pio_hora:
        currentBasicOptometryEdit.pio_d === "" &&
        currentBasicOptometryEdit.pio_i === ""
          ? ""
          : currentBasicOptometryEdit.pio_hora,
      fecha_actualizacion: moment().format("YYYY-MM-DD HH:mm:ss"),
    });
    setCurrentBasicOptometry({
      ...currentBasicOptometryEdit,
      pio_hora:
        currentBasicOptometryEdit.pio_d === "" &&
        currentBasicOptometryEdit.pio_i === ""
          ? ""
          : currentBasicOptometryEdit.pio_hora,
      fecha_actualizacion: moment().format("YYYY-MM-DD HH:mm:ss"),
    });
    setSelectedDate({
      id: response.idOptometria,
      text: currentBasicOptometryEdit.fecha,
      type: currentBasicOptometryEdit.tipo,
    });
    setOptometryId(response.idOptometria);
    props.saveLastOptIdVisited(response.idOptometria);
    props.createPopupQuestion(
      `Los cambios se han guardado con éxito.`,
      props.removePopupQuestion,
      null,
      "Entendido",
    );
  };

  const deleteBasicOptometry = async () => {
    await post("EliminarOptometriaBasica.php", {
      token: userData.token,
      optica: selectedOptic.id,
      idOptometria: optometryId,
      idUsuario: userData.id,
    });
  };

  const selectOptometryAfterDeleting = async () => {
    const response = await post("ListarFechasHistoricoOptometriaBasica.php", {
      token: userData.token,
      idPaciente: props.patientId,
      optica: selectedOptic.id,
    });
    if (response.length > 0) {
      setSelectedDate({
        id: response[0].idOptometria,
        text: response[0].fecha,
        type: response[0].tipo,
      });
      setOptometryId(response[0].idOptometria);
      setOptometryDateHistoryList(response);
      await getBasicOptometry(response[0].idOptometria);
      props.saveLastOptIdVisited(response[0].idOptometria);
    } else {
      setSelectedDate({
        id: -1,
        text: moment().format("YYYY-MM-DD HH:mm:ss"),
        type: currentBasicOptometryEdit.tipo,
      });
      setOptometryId(-1);
      props.saveLastOptIdVisited(-1);
      setCurrentBasicOptometry(basicOptometry);
      setCurrentBasicOptometryEdit(basicOptometry);
    }
  };

  const cancelChanges = async () => {
    if (optometryDateHistoryList.length > 0) {
      // 1. Si estamos creando una ficha, cargamos la última.
      if (optometryId === -1) {
        setSelectedDate({
          id: optometryDateHistoryList[0].idOptometria,
          text: optometryDateHistoryList[0].fecha,
          type: optometryDateHistoryList[0].tipo,
        });
        setOptometryId(optometryDateHistoryList[0].idOptometria);
        props.saveLastOptIdVisited(optometryDateHistoryList[0].idOptometria);
        await getBasicOptometry(optometryDateHistoryList[0].idOptometria);
      } else {
        // 2. Si estamos viendo una ficha, cancelamos los cambios.
        setCurrentBasicOptometryEdit(currentBasicOptometry);
      }
    } else {
      setCurrentBasicOptometryEdit(currentBasicOptometry);
    }
  };

  const resetOptometryState = async () => {
    basicOptometry.fecha = moment().format("YYYY-MM-DD HH:mm:ss");
    basicOptometry.fecha_revision = moment()
      .add(1, "years")
      .format("YYYY-MM-DD");
    basicOptometry.fecha_actualizacion = moment().format("YYYY-MM-DD HH:mm:ss");
    basicOptometry.idPaciente = props.patientId;
    basicOptometry.idOptometria = -1;
    setCurrentBasicOptometryEdit(basicOptometry);
    setCurrentBasicOptometry(basicOptometry);
    setOptometryId(-1);
    props.saveLastOptIdVisited(-1);
    // Establecer la nueva fecha (de creación) para el selectedDate
    setSelectedDate({
      id: -1,
      text: basicOptometry.fecha,
      type: currentBasicOptometryEdit.tipo,
    });
    canvasRef.current.loadSaveData(JSON.stringify(basicOptometry.esquema));
  };

  const transpositionRightEye = () => {
    const data = calculateTransposition(
      currentBasicOptometryEdit.esfera_d,
      currentBasicOptometryEdit.total_d,
      currentBasicOptometryEdit.intermedia_d,
      currentBasicOptometryEdit.cilindro_d,
      currentBasicOptometryEdit.eje_d,
    );
    setCurrentBasicOptometryEdit((prev) => ({
      ...prev,
      esfera_d: data.esferaT,
      total_d: data.totalCT,
      intermedia_d: data.totalIT,
      cilindro_d: data.cilindroT,
      eje_d: data.ejeT,
    }));
  };

  const transpositionLeftEye = () => {
    const data = calculateTransposition(
      currentBasicOptometryEdit.esfera_i,
      currentBasicOptometryEdit.total_i,
      currentBasicOptometryEdit.intermedia_i,
      currentBasicOptometryEdit.cilindro_i,
      currentBasicOptometryEdit.eje_i,
    );
    setCurrentBasicOptometryEdit((prev) => ({
      ...prev,
      esfera_i: data.esferaT,
      total_i: data.totalCT,
      intermedia_i: data.totalIT,
      cilindro_i: data.cilindroT,
      eje_i: data.ejeT,
    }));
  };

  function focusRequiredField() {
    const fields = [
      { value: currentBasicOptometryEdit.optometrista, elementId: 59 },
      { value: currentBasicOptometryEdit.oftalmologo, elementId: 60 },
    ];

    const emptyFields = fields.filter((field) => field.value === "");

    if (emptyFields.length > 0) {
      focusElement(emptyFields[0].elementId);
    }
  }

  const findEmptyOfficialPrescriptionField = () => {
    const fields = [
      {
        value: currentBasicOptometryEdit.esfera_d,
        label: "Esf (OD)",
        sectionName: "RX nueva",
      },
      {
        value: currentBasicOptometryEdit.cilindro_d,
        label: "Cil (OD)",
        sectionName: "RX nueva",
      },
      {
        value: currentBasicOptometryEdit.eje_d,
        label: "Eje (OD)",
        sectionName: "RX nueva",
      },
      {
        value: currentBasicOptometryEdit.cerca_d,
        label: "Add C (OD)",
        sectionName: "RX nueva",
      },
      {
        value: currentBasicOptometryEdit.prisma_d,
        label: "Prisma (OD)",
        sectionName: "Prisma",
      },
      {
        value: currentBasicOptometryEdit.base_d,
        label: "Prisma Base (OD)",
        sectionName: "Prisma",
      },
      {
        value: currentBasicOptometryEdit.base_d2,
        label: "Prisma º (OD)",
        sectionName: "Prisma",
      },
      {
        value: currentBasicOptometryEdit.esfera_i,
        label: "Esf (OI)",
        sectionName: "RX nueva",
      },
      {
        value: currentBasicOptometryEdit.cilindro_i,
        label: "Cil (OI)",
        sectionName: "RX nueva",
      },
      {
        value: currentBasicOptometryEdit.eje_i,
        label: "Eje (OI)",
        sectionName: "RX nueva",
      },
      {
        value: currentBasicOptometryEdit.cerca_i,
        label: "Add C (OI)",
        sectionName: "RX nueva",
      },
      {
        value: currentBasicOptometryEdit.prisma_i,
        label: "Prisma (OI)",
        sectionName: "Prisma",
      },
      {
        value: currentBasicOptometryEdit.base_i,
        label: "Prisma Base (OI)",
        sectionName: "Prisma",
      },
      {
        value: currentBasicOptometryEdit.base_i2,
        label: "Prisma º (OI)",
        sectionName: "Prisma",
      },
      {
        value: currentBasicOptometryEdit.nasopupilar_lejos_d,
        label: "NPD / VL",
        sectionName: "DIP (Distancia Interpupilar)",
      },
    ];

    return (
      fields.find((field) => field.value === "") || null
    );
  };

  const printFile = async (data) => {
    if (optometryId === -1) return;
    const response = await post(
      "/support-extra/gestionDocumental/GenerarFichaOptometria.php",
      {
        token: userData.token,
        idOptica: selectedOptic.id,
        idPaciente: currentBasicOptometryEdit.idPaciente,
        idOptometriaBasica: optometryId,
        tipoFicha: data.record,
        observaciones: data.observations,
        email: data.email,
      },
    );
    // console.log(
      // "GENERANDO: ",
      // {
        // token: userData.token,
        // idOptica: selectedOptic.id,
        // idPaciente: currentBasicOptometryEdit.idPaciente,
        // idOptometriaBasica: optometryId,
        // tipoFicha: data.record,
        // observaciones: data.observations,
        // email: data.email,
      // },
      // response,
    // );
    if (response.error !== "") {
      props.createPopupQuestion(
        response.error,
        () => {
          props.removePopupQuestion();
        },
        null,
        "Entendido",
      );
    } else {
      const a = document.createElement("a");
      a.href = response.fichero;
      a.download = `ficha_optometria.pdf`;
      a.click();
    }
  };

  useEffect(() => {
    const loadData = async () => {
      await getOptometryDateHistoryList();

      if (optometryId !== -1) {
        await getBasicOptometry(optometryId);
      } else {
        const now = moment().format("YYYY-MM-DD HH:mm:ss");
        setSelectedDate({
          id: -1,
          text: now,
          type: currentBasicOptometryEdit.tipo,
        });
        setCurrentBasicOptometryEdit({
          ...basicOptometry,
          fecha: now,
        });
        setCurrentBasicOptometry({
          ...basicOptometry,
          fecha: now,
        });
      }
      focusElement(45);
      setLoadingData(false);
    };
    loadData();
  }, [optometryId]);

  useEffect(() => {
    const loadData = async () => {
      await getPreviousRX();
      if (selectedDate.id === -1 && currentBasicOptometryEdit.tipo !== "") {
        // Obtener los datos de la optometría anterior (si hay) y actualizar la estructura.
        await getPreviousRX();
        await getPreviousBasicOptometryData();
      }
      focusElement(45);
    };
    loadData();
  }, [selectedDate, currentBasicOptometryEdit.tipo]);

  useEffect(() => {
    // console.log(
      // "PENDIENTES: ",
      // currentBasicOptometry,
      // currentBasicOptometryEdit,
    // );
    props.pendingChanges({
      changes: !areObjectsEqual(
        currentBasicOptometry,
        currentBasicOptometryEdit,
      ),
      dataToSave: currentBasicOptometryEdit,
    });
  }, [currentBasicOptometryEdit, props.pendingChanges]);

  useEffect(() => {
    const loadData = async () => {
      if (props.updateOpt) {
        props.updateOptAction();
        setOptometryId(props.optometryId);
        await getBasicOptometry(props.optometryId);
      }
    };
    loadData();
  }, [props.updateOpt]);

  useEffect(() => {
    if (optometryId === -1) {
      props.createPopupQuestion(
        `Seleccione qué tipo de optometría básica desea.`,
        async () => {
          setCurrentBasicOptometryEdit((prev) => ({
            ...prev,
            tipo: "Gafas",
          }));
          props.removePopupQuestion();
        },
        async () => {
          setCurrentBasicOptometryEdit((prev) => ({
            ...prev,
            tipo: "LC",
          }));
          props.removePopupQuestion();
        },
        "Gafas",
        "Lente de contacto",
      );
    }
  }, [optometryId]);

  return (
    <>
      {loadingData && (
        <LoadingScreen message="Cargando ficha de optometría..."></LoadingScreen>
      )}
      {!loadingData && (
        <div className="tab-content-screen bg-transparent">
          <div className="content-grid">
            {reportPopup && (
              <BasicOptometryReportPopup
                createPopupQuestion={props.createPopupQuestion}
                removePopupQuestion={props.removePopupQuestion}
                onExport={async (data) => {
                  await printFile(data);
                }}
                onGenerateOfficialPrescription={() => {
                  const emptyField = findEmptyOfficialPrescriptionField();
                  if (emptyField) {
                    props.createPopupQuestion(
                      `El campo ${emptyField.label} de la sección ${emptyField.sectionName} no puede estar vacío. Asigne un valor y guarde la ficha.`,
                      () => {
                        props.removePopupQuestion();
                      },
                      null,
                      "Cerrar",
                    );
                    return;
                  }
                  setCGCOOPopup(true);
                }}
                onClose={() => {
                  setReportPopup(false);
                }}
              />
            )}
            <PopupCGCOOOftalmica
              show={CGCOOPopup}
              idFichaLentillas={optometryId}
              agenteFicha={currentBasicOptometryEdit.optometrista}
              createPopupQuestion={props.createPopupQuestion}
              removePopupQuestion={props.removePopupQuestion}
              onAccept={() => {
                setCGCOOPopup(false);
              }}
              onCancel={() => {
                setCGCOOPopup(false);
              }}
            />
            <div
              className="popup-screen-box external-container"
              style={{ gridColumn: "1/span 3", gridRow: "1/span 1" }}
            >
              <div className="popup-screen-box-info">
                <div className="cell-extra">
                  <span className="label">Creación</span>
                </div>
                <div className="cell-extra w-220">
                  <div className="input-data input-full">
                    <input
                      type="datetime-local"
                      max="9999-12-31T23:59"
                      step="1"
                      tabIndex={41}
                      className="input-field input-cell"
                      value={currentBasicOptometryEdit.fecha}
                      onChange={(e) => {
                        setCurrentBasicOptometryEdit({
                          ...currentBasicOptometryEdit,
                          fecha: e.target.value,
                        });
                      }}
                      onKeyUp={(e) => inputOnEnter(e)}
                    ></input>
                  </div>
                </div>
                <div className="cell-extra">
                  <span className="label">Revisión</span>
                </div>
                <div className="cell-extra w-220">
                  <div className="input-data input-full">
                    <input
                      type="date"
                      max="9999-12-31"
                      tabIndex={42}
                      className="input-field"
                      value={currentBasicOptometryEdit.fecha_revision}
                      onChange={(e) => {
                        setCurrentBasicOptometryEdit({
                          ...currentBasicOptometryEdit,
                          fecha_revision: e.target.value,
                        });
                      }}
                      onKeyUp={(e) => inputOnEnter(e)}
                    ></input>
                  </div>
                </div>
                <div className="cell-extra">
                  <span className="label">Actualización</span>
                </div>
                <div className="cell-extra w-220">
                  <InputData
                    size={0}
                    input={moment(
                      currentBasicOptometryEdit.fecha_actualizacion,
                    ).format("DD/MM/YYYY HH:mm:ss")}
                    inactive={true}
                  ></InputData>
                </div>
                <div className="cell-extra">
                  <span className="label">
                    Histórico ({optometryDateHistoryList.length})
                  </span>
                </div>
                <div className="cell-extra w-100p">
                  <DropdownFilter
                    optionList={optometryDateHistoryList.map((item) => ({
                      id: item.idOptometria,
                      text: `${moment(item.fecha, "YYYY-MM-DD HH:mm:ss").format(
                        "DD/MM/YYYY HH:mm:ss",
                      )} (${item.tipo})`,
                      active: selectedDate.id === item.idOptometria,
                    }))}
                    op={moment(selectedDate.text, "YYYY-MM-DD HH:mm:ss").format(
                      "DD/MM/YYYY HH:mm:ss",
                    )}
                    selectedOptions={[]}
                    disabled={optometryId === -1}
                    onChange={async (e) => {
                      await getBasicOptometry(e.id);
                      await getOptometryDateHistoryList();
                      setSelectedDate({
                        id: e.id,
                        text: moment(e.text, "DD/MM/YYYY HH:mm:ss").format(
                          "YYYY-MM-DD HH:mm:ss",
                        ),
                        type: e.type,
                      });
                      props.saveLastOptIdVisited(e.id);
                      setOptometryId(e.id);
                    }}
                  ></DropdownFilter>
                </div>
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", gap: 10 }}
              >
                <div
                  className={`check-container-content cell-label cell-start-content ${
                    currentBasicOptometryEdit.tipo === "Gafas"
                      ? "active-check-container"
                      : ""
                  }`}
                  style={{ height: 28, cursor: "auto" }}
                >
                  <span>Gafas</span>
                </div>
                <div
                  className={`check-container-content cell-label cell-start-content ${
                    currentBasicOptometryEdit.tipo === "LC"
                      ? "active-check-container"
                      : ""
                  }`}
                  style={{
                    height: 28,
                    justifyContent: "space-between",
                    cursor: "auto",
                  }}
                >
                  <span>Lente contacto</span>
                </div>
              </div>
            </div>
            <div
              className="popup-screen-box external-container"
              style={{ gridColumn: "4/span 3", gridRow: "1/span 1" }}
            >
              <ButtonIconV
                text="Nueva"
                icon={
                  optometryId !== -1
                    ? "/images/create-blue.svg"
                    : "/images/create-gray.svg"
                }
                onClick={async () => {
                  if (optometryId !== -1) {
                    if (
                      !areObjectsEqual(
                        currentBasicOptometry,
                        currentBasicOptometryEdit,
                      )
                    ) {
                      props.createPopupQuestion(
                        `Existen cambios sin guardar en la ficha actual. ¿Desea guardar los cambios antes de crear una nueva optometría?`,
                        async () => {
                          await saveBasicOptometry();
                          props.removePopupQuestion();
                          resetOptometryState();
                        },
                        async () => {
                          props.removePopupQuestion();
                          resetOptometryState();
                        },
                        "Sí",
                        "No",
                      );
                    } else {
                      resetOptometryState();
                    }
                  }
                }}
              ></ButtonIconV>
              <ButtonIconV
                text="Guardar"
                icon="/images/save-blue.svg"
                onClick={async () => {
                  if (
                    (currentBasicOptometryEdit.optometrista !== "" ||
                      currentBasicOptometryEdit.oftalmologo !== "") &&
                    (validateOptometryData(currentBasicOptometryEdit) ||
                      currentBasicOptometryEdit.esquema.lines.length > 0 ||
                      props.numObservations > 0)
                  ) {
                    await saveBasicOptometry();
                    await getOptometryDateHistoryList();
                    props.updateTab();
                  } else {
                    props.createPopupQuestion(
                      `Debe seleccionar un optometrista o un oftalmólogo, rellenar al menos un campo de las secciones RX Nueva, SC, CC, DIP o Queratometría, añadir esquema o alguna observación.`,
                      () => {
                        focusRequiredField();
                        props.removePopupQuestion();
                      },
                      null,
                      "Entendido",
                    );
                  }
                }}
              ></ButtonIconV>
              <ButtonIconV
                text="Cancelar"
                icon="/images/cancel-blue.svg"
                onClick={async () => {
                  if (
                    optometryDateHistoryList.length === 0 &&
                    areObjectsEqual(
                      currentBasicOptometry,
                      currentBasicOptometryEdit,
                    )
                  ) {
                    props.removePopupQuestion();
                  } else if (
                    !areObjectsEqual(
                      currentBasicOptometry,
                      currentBasicOptometryEdit,
                    ) ||
                    optometryId === -1
                  ) {
                    props.createPopupQuestion(
                      `¿Desea cancelar los cambios realizados?`,
                      async () => {
                        await cancelChanges();
                        props.removePopupQuestion();
                      },
                      props.removePopupQuestion,
                      "Sí",
                      "No",
                    );
                  }
                }}
              ></ButtonIconV>
              <ButtonIconV
                text="Recargar"
                icon={
                  optometryId !== -1
                    ? "/images/update-blue.svg"
                    : "/images/update-gray.svg"
                }
                onClick={() => {
                  if (optometryId !== -1) {
                    props.createPopupQuestion(
                      `¿Desea recargar esta ficha de optometría?`,
                      async () => {
                        await getBasicOptometry(optometryId);
                        props.removePopupQuestion();
                      },
                      props.removePopupQuestion,
                      "Sí",
                      "No",
                    );
                  }
                }}
              ></ButtonIconV>
              <ButtonIconV
                text="Eliminar"
                icon={
                  optometryId !== -1
                    ? "/images/remove-blue.svg"
                    : "/images/remove-gray.svg"
                }
                onClick={() => {
                  if (optometryId !== -1) {
                    props.createPopupQuestion(
                      `¿Desea eliminar esta ficha de optometría?`,
                      async () => {
                        await deleteBasicOptometry();
                        await getOptometryDateHistoryList();
                        await selectOptometryAfterDeleting();
                        props.updateTab();
                        props.removePopupQuestion();
                      },
                      props.removePopupQuestion,
                      "Sí",
                      "No",
                    );
                  }
                }}
              ></ButtonIconV>
              <ButtonIconV
                text="Informe"
                icon={
                  optometryId !== -1
                    ? "/images/print-blue.svg"
                    : "/images/print-gray.svg"
                }
                onClick={async () => {
                  if (optometryId !== -1) {
                    setReportPopup(true);
                  }
                }}
              ></ButtonIconV>
            </div>
            <div
              className="external-container"
              style={{
                display: "flex",
                flexDirection: "column",
                gridColumn: "1/span 3",
                gridRow: "2/span 2",
              }}
            >
              <div className="opt-table-container">
                <div className="opt-table-title">RX anterior</div>
                <div className="opt-table-content" id="rx-anterior">
                  <div className="cell"></div>
                  <div className="cell cell-label">Esf</div>
                  <div className="cell cell-label">Cil</div>
                  <div className="cell cell-label">Eje</div>
                  <div className="cell"></div>
                  <div className="cell cell-label">Add I</div>
                  <div className="cell cell-label">Total I</div>
                  <div className="cell cell-label">Add C</div>
                  <div className="cell cell-label">Total C</div>
                  <div className="cell"></div>
                  <div className="cell cell-label cell-start-content">OD</div>
                  <div className="cell">
                    <InputData
                      type="type-optofloat"
                      size={0}
                      input={previousRX.esfera_d}
                      onChange={(e) => {}}
                      inactive={true}
                    ></InputData>
                  </div>
                  <div className="cell">
                    <InputData
                      type="type-optofloat"
                      size={0}
                      input={previousRX.cilindro_d}
                      onChange={(e) => {}}
                      inactive={true}
                    ></InputData>
                  </div>
                  <div className="cell">
                    <InputData
                      type="type-only-positive-numbers"
                      size={0}
                      maxLength={3}
                      input={previousRX.eje_d}
                      onChange={(e) => {}}
                      inactive={true}
                    ></InputData>
                  </div>
                  <div className="cell"></div>
                  <div className="cell">
                    <InputData
                      type="type-positive-optofloat"
                      size={0}
                      input={previousRX.adicion_d}
                      onChange={(e) => {}}
                      inactive={true}
                    ></InputData>
                  </div>
                  <div className="cell">
                    <InputData
                      type="type-optofloat"
                      size={0}
                      input={previousRX.intermedia_d}
                      onChange={(e) => {}}
                      inactive={true}
                    ></InputData>
                  </div>
                  <div className="cell">
                    <InputData
                      type="type-positive-optofloat"
                      size={0}
                      input={previousRX.cerca_d}
                      onChange={(e) => {}}
                      inactive={true}
                    ></InputData>
                  </div>
                  <div className="cell">
                    <InputData
                      type="type-optofloat"
                      size={0}
                      input={previousRX.total_d}
                      onChange={(e) => {}}
                      inactive={true}
                    ></InputData>
                  </div>
                  <div className="cell"></div>
                  <div className="cell cell-label cell-start-content">OI</div>
                  <div className="cell">
                    <InputData
                      type="type-optofloat"
                      size={0}
                      input={previousRX.esfera_i}
                      onChange={(e) => {}}
                      inactive={true}
                    ></InputData>
                  </div>
                  <div className="cell">
                    <InputData
                      type="type-optofloat"
                      size={0}
                      input={previousRX.cilindro_i}
                      onChange={(e) => {}}
                      inactive={true}
                    ></InputData>
                  </div>
                  <div className="cell">
                    <InputData
                      type="type-only-positive-numbers"
                      size={0}
                      maxLength={3}
                      input={previousRX.eje_i}
                      onChange={(e) => {}}
                      inactive={true}
                    ></InputData>
                  </div>
                  <div className="cell"></div>
                  <div className="cell">
                    <InputData
                      type="type-positive-optofloat"
                      size={0}
                      input={previousRX.adicion_i}
                      onChange={(e) => {}}
                      inactive={true}
                    ></InputData>
                  </div>
                  <div className="cell">
                    <InputData
                      type="type-optofloat"
                      size={0}
                      input={previousRX.intermedia_i}
                      onChange={(e) => {}}
                      inactive={true}
                    ></InputData>
                  </div>
                  <div className="cell">
                    <InputData
                      type="type-positive-optofloat"
                      size={0}
                      input={previousRX.cerca_i}
                      onChange={(e) => {}}
                      inactive={true}
                    ></InputData>
                  </div>
                  <div className="cell">
                    <InputData
                      type="type-optofloat"
                      size={0}
                      input={previousRX.total_i}
                      onChange={(e) => {}}
                      inactive={true}
                    ></InputData>
                  </div>
                  <div className="cell cell-start-content">
                    <button
                      className="cell-icon"
                      onClick={() => {
                        if (
                          Object.values(previousRX).some(
                            (value) => value !== "",
                          )
                        ) {
                          copyToNewOptometry();
                        }
                      }}
                    >
                      <img
                        src="/images/extract-blue.svg"
                        loading="lazy"
                        alt="Icon"
                        className="cell-icon"
                        data-tooltip-id="tt1"
                      ></img>
                      <TooltipBox
                        id="tt1"
                        content={<div className="cell">Copiar a RX nueva</div>}
                      ></TooltipBox>
                    </button>
                  </div>
                  <div className="cell cell-label combined-cells-2">
                    {previousRX.optometrista !== ""
                      ? "Optometrista"
                      : previousRX.oftalmologo !== ""
                        ? "Oftalmologo"
                        : ""}
                  </div>
                  <div className="cell combined-cells-7">
                    <InputData
                      type="type-alphaext"
                      size={0}
                      input={
                        previousRX.optometrista !== ""
                          ? previousRX.optometrista
                          : previousRX.oftalmologo !== ""
                            ? previousRX.oftalmologo
                            : ""
                      }
                      onChange={(e) => {}}
                      inactive={true}
                    ></InputData>
                  </div>
                  <div className="cell"></div>
                </div>
              </div>
              <div className="opt-table-container">
                <div className="opt-table-title">RX nueva</div>
                <div className="opt-table-content" id="rx-nueva">
                  <div className="cell"></div>
                  <div className="cell cell-label">Esf</div>
                  <div className="cell cell-label">Cil</div>
                  <div className="cell cell-label">Eje</div>
                  <div className="cell"></div>
                  <div className="cell cell-label">Add I</div>
                  <div className="cell cell-label">Total I</div>
                  <div className="cell cell-label">Add C</div>
                  <div className="cell cell-label">Total C</div>
                  <div className="cell"></div>
                  <div className="cell cell-label cell-start-content">OD</div>
                  <div className="cell">
                    <InputDataControl
                      tabIndex={45}
                      type="type-optofloat"
                      size={0}
                      input={currentBasicOptometryEdit.esfera_d}
                      minValue=""
                      maxValue=""
                      step={0.25}
                      numDecimales=""
                      createPopupQuestion={props.createPopupQuestion}
                      removePopupQuestion={props.removePopupQuestion}
                      onChange={(e) => {
                        setCurrentBasicOptometryEdit({
                          ...currentBasicOptometryEdit,
                          esfera_d: e,
                        });
                      }}
                      onBlur={() => {
                        const updates = { ...currentBasicOptometryEdit };

                        // Add I y Total I
                        if (currentBasicOptometryEdit.adicion_d) {
                          updates.intermedia_d = calculateTotalLens(
                            currentBasicOptometryEdit.esfera_d,
                            currentBasicOptometryEdit.adicion_d,
                          );
                        } else if (currentBasicOptometryEdit.intermedia_d) {
                          updates.adicion_d = calculateAddFromTotal(
                            currentBasicOptometryEdit.esfera_d,
                            currentBasicOptometryEdit.intermedia_d,
                          );
                        }

                        // Add D y Total D
                        if (currentBasicOptometryEdit.cerca_d) {
                          updates.total_d = calculateTotalLens(
                            currentBasicOptometryEdit.esfera_d,
                            currentBasicOptometryEdit.cerca_d,
                          );
                        } else if (currentBasicOptometryEdit.total_d) {
                          updates.cerca_d = calculateAddFromTotal(
                            currentBasicOptometryEdit.esfera_d,
                            currentBasicOptometryEdit.total_d,
                          );
                        }

                        setCurrentBasicOptometryEdit(updates);
                      }}
                    ></InputDataControl>
                  </div>
                  <div className="cell">
                    <InputDataControl
                      tabIndex={46}
                      type="type-optofloat"
                      size={0}
                      input={currentBasicOptometryEdit.cilindro_d}
                      minValue=""
                      maxValue=""
                      step={0.25}
                      numDecimales=""
                      createPopupQuestion={props.createPopupQuestion}
                      removePopupQuestion={props.removePopupQuestion}
                      onChange={(e) => {
                        setCurrentBasicOptometryEdit({
                          ...currentBasicOptometryEdit,
                          cilindro_d: e,
                        });
                      }}
                    ></InputDataControl>
                  </div>
                  <div className="cell">
                    <InputData
                      tabIndex={47}
                      type="type-only-positive-numbers"
                      size={0}
                      maxLength={3}
                      input={currentBasicOptometryEdit.eje_d}
                      onChange={(e) => {
                        setCurrentBasicOptometryEdit({
                          ...currentBasicOptometryEdit,
                          eje_d: e,
                        });
                      }}
                    ></InputData>
                  </div>
                  <div className="cell"></div>
                  <div className="cell">
                    <InputDataControl
                      tabIndex={48}
                      type="type-optofloat"
                      size={0}
                      input={currentBasicOptometryEdit.adicion_d}
                      minValue=""
                      maxValue=""
                      step={0.25}
                      numDecimales=""
                      createPopupQuestion={props.createPopupQuestion}
                      removePopupQuestion={props.removePopupQuestion}
                      onChange={(e) => {
                        setCurrentBasicOptometryEdit({
                          ...currentBasicOptometryEdit,
                          adicion_d: e,
                        });
                      }}
                      onBlur={() => {
                        if (currentBasicOptometryEdit.adicion_d !== "") {
                          setCurrentBasicOptometryEdit({
                            ...currentBasicOptometryEdit,
                            adicion_i: currentBasicOptometryEdit.adicion_d,
                            intermedia_d: calculateTotalLens(
                              currentBasicOptometryEdit.esfera_d,
                              currentBasicOptometryEdit.adicion_d,
                            ),
                            intermedia_i: calculateTotalLens(
                              currentBasicOptometryEdit.esfera_i,
                              currentBasicOptometryEdit.adicion_i,
                            ),
                          });
                        }
                      }}
                    ></InputDataControl>
                  </div>
                  <div className="cell">
                    <InputData
                      tabIndex={49}
                      type="type-optofloat"
                      size={0}
                      input={currentBasicOptometryEdit.intermedia_d}
                      onChange={(e) => {
                        setCurrentBasicOptometryEdit({
                          ...currentBasicOptometryEdit,
                          intermedia_d: e,
                        });
                      }}
                      onBlur={() => {
                        if (currentBasicOptometryEdit.intermedia_d !== "") {
                          setCurrentBasicOptometryEdit({
                            ...currentBasicOptometryEdit,
                            adicion_d: calculateAddFromTotal(
                              currentBasicOptometryEdit.esfera_d,
                              currentBasicOptometryEdit.intermedia_d,
                            ),
                          });
                        }
                      }}
                    ></InputData>
                  </div>
                  <div className="cell">
                    <InputDataControl
                      tabIndex={50}
                      type="type-optofloat"
                      size={0}
                      input={currentBasicOptometryEdit.cerca_d}
                      minValue=""
                      maxValue=""
                      step={0.25}
                      numDecimales=""
                      createPopupQuestion={props.createPopupQuestion}
                      removePopupQuestion={props.removePopupQuestion}
                      onChange={(e) => {
                        setCurrentBasicOptometryEdit({
                          ...currentBasicOptometryEdit,
                          cerca_d: e,
                        });
                      }}
                      onBlur={() => {
                        if (currentBasicOptometryEdit.cerca_d !== "") {
                          setCurrentBasicOptometryEdit({
                            ...currentBasicOptometryEdit,
                            cerca_i: currentBasicOptometryEdit.cerca_d,
                            total_d: calculateTotalLens(
                              currentBasicOptometryEdit.esfera_d,
                              currentBasicOptometryEdit.cerca_d,
                            ),
                            total_i: calculateTotalLens(
                              currentBasicOptometryEdit.esfera_i,
                              currentBasicOptometryEdit.cerca_i,
                            ),
                          });
                        }
                      }}
                    ></InputDataControl>
                  </div>
                  <div className="cell">
                    <InputData
                      tabIndex={51}
                      type="type-optofloat"
                      size={0}
                      input={currentBasicOptometryEdit.total_d}
                      onChange={(e) => {
                        setCurrentBasicOptometryEdit({
                          ...currentBasicOptometryEdit,
                          total_d: e,
                        });
                      }}
                      onBlur={() => {
                        if (currentBasicOptometryEdit.total_d !== "") {
                          setCurrentBasicOptometryEdit({
                            ...currentBasicOptometryEdit,
                            cerca_d: calculateAddFromTotal(
                              currentBasicOptometryEdit.esfera_d,
                              currentBasicOptometryEdit.total_d,
                            ),
                          });
                        }
                      }}
                    ></InputData>
                  </div>
                  <div className="cell cell-start-content">
                    <button
                      className="cell-icon"
                      onClick={() => {
                        transpositionRightEye();
                      }}
                    >
                      <img
                        src="/images/update-fill-blue.svg"
                        loading="lazy"
                        alt="Icon"
                        className="cell-icon"
                        data-tooltip-id="tt2"
                      ></img>
                      <TooltipBox
                        id="tt2"
                        content={
                          <div className="cell">Transposición ojo D</div>
                        }
                      ></TooltipBox>
                    </button>
                  </div>
                  <div className="cell cell-label cell-start-content">OI</div>
                  <div className="cell">
                    <InputDataControl
                      tabIndex={52}
                      type="type-optofloat"
                      size={0}
                      input={currentBasicOptometryEdit.esfera_i}
                      minValue=""
                      maxValue=""
                      step={0.25}
                      numDecimales=""
                      createPopupQuestion={props.createPopupQuestion}
                      removePopupQuestion={props.removePopupQuestion}
                      onChange={(e) => {
                        setCurrentBasicOptometryEdit({
                          ...currentBasicOptometryEdit,
                          esfera_i: e,
                        });
                      }}
                      onBlur={() => {
                        const updates = { ...currentBasicOptometryEdit };

                        // Add I y Total I
                        if (currentBasicOptometryEdit.adicion_i) {
                          updates.intermedia_i = calculateTotalLens(
                            currentBasicOptometryEdit.esfera_i,
                            currentBasicOptometryEdit.adicion_i,
                          );
                        } else if (currentBasicOptometryEdit.intermedia_i) {
                          updates.adicion_i = calculateAddFromTotal(
                            currentBasicOptometryEdit.esfera_i,
                            currentBasicOptometryEdit.intermedia_i,
                          );
                        }

                        // Add D y Total D
                        if (currentBasicOptometryEdit.cerca_i) {
                          updates.total_i = calculateTotalLens(
                            currentBasicOptometryEdit.esfera_i,
                            currentBasicOptometryEdit.cerca_i,
                          );
                        } else if (currentBasicOptometryEdit.total_i) {
                          updates.cerca_i = calculateAddFromTotal(
                            currentBasicOptometryEdit.esfera_i,
                            currentBasicOptometryEdit.total_i,
                          );
                        }

                        setCurrentBasicOptometryEdit(updates);
                      }}
                    ></InputDataControl>
                  </div>
                  <div className="cell">
                    <InputDataControl
                      tabIndex={53}
                      type="type-optofloat"
                      size={0}
                      input={currentBasicOptometryEdit.cilindro_i}
                      minValue=""
                      maxValue=""
                      step={0.25}
                      numDecimales=""
                      createPopupQuestion={props.createPopupQuestion}
                      removePopupQuestion={props.removePopupQuestion}
                      onChange={(e) => {
                        setCurrentBasicOptometryEdit({
                          ...currentBasicOptometryEdit,
                          cilindro_i: e,
                        });
                      }}
                    ></InputDataControl>
                  </div>
                  <div className="cell">
                    <InputData
                      tabIndex={54}
                      type="type-only-positive-numbers"
                      size={0}
                      maxLength={3}
                      input={currentBasicOptometryEdit.eje_i}
                      onChange={(e) => {
                        setCurrentBasicOptometryEdit({
                          ...currentBasicOptometryEdit,
                          eje_i: e,
                        });
                      }}
                    ></InputData>
                  </div>
                  <div className="cell"></div>
                  <div className="cell">
                    <InputDataControl
                      tabIndex={55}
                      type="type-optofloat"
                      size={0}
                      input={currentBasicOptometryEdit.adicion_i}
                      minValue=""
                      maxValue=""
                      step={0.25}
                      numDecimales=""
                      createPopupQuestion={props.createPopupQuestion}
                      removePopupQuestion={props.removePopupQuestion}
                      onChange={(e) => {
                        setCurrentBasicOptometryEdit({
                          ...currentBasicOptometryEdit,
                          adicion_i: e,
                        });
                      }}
                      onBlur={() => {
                        if (currentBasicOptometryEdit.adicion_i !== "") {
                          setCurrentBasicOptometryEdit({
                            ...currentBasicOptometryEdit,
                            intermedia_i: calculateTotalLens(
                              currentBasicOptometryEdit.esfera_i,
                              currentBasicOptometryEdit.adicion_i,
                            ),
                          });
                        }
                      }}
                    ></InputDataControl>
                  </div>
                  <div className="cell">
                    <InputData
                      tabIndex={56}
                      type="type-optofloat"
                      size={0}
                      input={currentBasicOptometryEdit.intermedia_i}
                      onChange={(e) => {
                        setCurrentBasicOptometryEdit({
                          ...currentBasicOptometryEdit,
                          intermedia_i: e,
                        });
                      }}
                      onBlur={() => {
                        if (currentBasicOptometryEdit.intermedia_i !== "") {
                          setCurrentBasicOptometryEdit({
                            ...currentBasicOptometryEdit,
                            adicion_i: calculateAddFromTotal(
                              currentBasicOptometryEdit.esfera_i,
                              currentBasicOptometryEdit.intermedia_i,
                            ),
                          });
                        }
                      }}
                    ></InputData>
                  </div>
                  <div className="cell">
                    <InputDataControl
                      tabIndex={57}
                      type="type-optofloat"
                      size={0}
                      input={currentBasicOptometryEdit.cerca_i}
                      minValue=""
                      maxValue=""
                      step={0.25}
                      numDecimales=""
                      createPopupQuestion={props.createPopupQuestion}
                      removePopupQuestion={props.removePopupQuestion}
                      onChange={(e) => {
                        setCurrentBasicOptometryEdit({
                          ...currentBasicOptometryEdit,
                          cerca_i: e,
                        });
                      }}
                      onBlur={() => {
                        if (currentBasicOptometryEdit.cerca_i !== "") {
                          setCurrentBasicOptometryEdit({
                            ...currentBasicOptometryEdit,
                            total_i: calculateTotalLens(
                              currentBasicOptometryEdit.esfera_i,
                              currentBasicOptometryEdit.cerca_i,
                            ),
                          });
                        }
                      }}
                    ></InputDataControl>
                  </div>
                  <div className="cell">
                    <InputData
                      tabIndex={58}
                      type="type-optofloat"
                      size={0}
                      input={currentBasicOptometryEdit.total_i}
                      onChange={(e) => {
                        setCurrentBasicOptometryEdit({
                          ...currentBasicOptometryEdit,
                          total_i: e,
                        });
                      }}
                      onBlur={() => {
                        if (currentBasicOptometryEdit.total_i !== "") {
                          setCurrentBasicOptometryEdit({
                            ...currentBasicOptometryEdit,
                            cerca_i: calculateAddFromTotal(
                              currentBasicOptometryEdit.esfera_i,
                              currentBasicOptometryEdit.total_i,
                            ),
                          });
                        }
                      }}
                    ></InputData>
                  </div>
                  <div className="cell cell-start-content">
                    <button
                      className="cell-icon"
                      onClick={() => {
                        transpositionLeftEye();
                      }}
                    >
                      <img
                        src="/images/update-fill-blue.svg"
                        loading="lazy"
                        alt="Icon"
                        className="cell-icon"
                        data-tooltip-id="tt3"
                      ></img>
                      <TooltipBox
                        id="tt3"
                        content={
                          <div className="cell">Transposición ojo I</div>
                        }
                      ></TooltipBox>
                    </button>
                  </div>
                  <div className="cell cell-label combined-cells-2  cell-start-content">
                    Optometrista (*)
                  </div>
                  <div className="cell cell-label combined-cells-7  cell-start-content">
                    <Dropdown
                      id="rx-nueva-optometrista"
                      tabIndex={59}
                      optionList={optometristList}
                      size={0}
                      mandatory={false}
                      op={currentBasicOptometryEdit.optometrista}
                      onChange={(e) => {
                        setCurrentBasicOptometryEdit({
                          ...currentBasicOptometryEdit,
                          optometrista: e.text,
                        });
                      }}
                    ></Dropdown>
                  </div>
                  <div className="cell"></div>
                  <div className="cell cell-label combined-cells-2  cell-start-content">
                    Oftalmólogo/a (*)
                  </div>
                  <div className="cell cell-label combined-cells-7  cell-start-content">
                    <Dropdown
                      id="rx-nueva-oftalmologo"
                      tabIndex={60}
                      optionList={ophthalmologistList}
                      size={0}
                      mandatory={false}
                      op={currentBasicOptometryEdit.oftalmologo}
                      onChange={(e) => {
                        setCurrentBasicOptometryEdit({
                          ...currentBasicOptometryEdit,
                          oftalmologo: e.text,
                        });
                      }}
                    ></Dropdown>
                  </div>
                  <div className="cell"></div>
                  <div className="cell cell-label combined-cells-2  cell-start-content">
                    Corrección
                  </div>
                  <div className="cell cell-label combined-cells-4  cell-start-content">
                    <Dropdown
                      id="rx-nueva-correccion"
                      tabIndex={61}
                      optionList={CORRECCIONLIST}
                      size={0}
                      op={currentBasicOptometryEdit.tipo_correccion}
                      onChange={(e) => {
                        setCurrentBasicOptometryEdit({
                          ...currentBasicOptometryEdit,
                          tipo_correccion: e.text,
                        });
                      }}
                    ></Dropdown>
                  </div>
                  <div className="cell cell-label combined-cells-3 cell-end-content">
                    <div
                      className={`check-container-content ${
                        currentBasicOptometryEdit.remitir_oftalmologo
                          ? "active-check-container"
                          : ""
                      }`}
                      onClick={() => {
                        setCurrentBasicOptometryEdit({
                          ...currentBasicOptometryEdit,
                          remitir_oftalmologo:
                            !currentBasicOptometryEdit.remitir_oftalmologo,
                        });
                      }}
                    >
                      Derivar a oftalmología
                      <div className="radio-op" style={{ width: "auto" }}>
                        <CheckBox
                          tabIndex={62}
                          active={currentBasicOptometryEdit.remitir_oftalmologo}
                          onClick={() => {}}
                        ></CheckBox>
                      </div>
                    </div>
                  </div>
                  <div className="cell"></div>
                </div>
              </div>
            </div>
            <div
              className="opt-table-container external-container"
              style={{ gridColumn: "4/span 3", gridRow: "2/span 1" }}
            >
              <div className="opt-table-title">Queratometría</div>
              <div className="opt-table-content" id="queratometria">
                <div className="cell combined-cells-3"></div>
                <div className="cell cell-label">OD</div>
                <div className="cell combined-cells-3"></div>
                <div className="cell cell-label">H</div>
                <div className="cell">
                  <InputData
                    tabIndex={90}
                    type="type-float2"
                    size={0}
                    input={currentBasicOptometryEdit.h_od_dp}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        h_od_dp: e,
                      });
                    }}
                    onBlur={(e) => {
                      setCurrentBasicOptometryEdit((prev) => ({
                        ...prev,
                        h_od_mm:
                          e !== ""
                            ? Math.round((337.5 / Number(e)) * 100) / 100
                            : currentBasicOptometryEdit.h_od_mm,
                      }));
                    }}
                  ></InputData>
                </div>
                <div className="cell cell-label cell-start-content">dp</div>
                <div className="cell">
                  <InputData
                    tabIndex={91}
                    type="type-float2"
                    size={0}
                    input={currentBasicOptometryEdit.h_od_mm}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        h_od_mm: e,
                      });
                    }}
                    onBlur={(e) => {
                      setCurrentBasicOptometryEdit((prev) => ({
                        ...prev,
                        h_od_dp:
                          e !== ""
                            ? Math.round((337.5 / Number(e)) * 100) / 100
                            : currentBasicOptometryEdit.h_od_dp,
                      }));
                    }}
                  ></InputData>
                </div>
                <div className="cell cell-label cell-start-content">m/m</div>
                <div className="cell">
                  <InputData
                    tabIndex={92}
                    type="type-only-positive-numbers"
                    maxLength={3}
                    size={0}
                    input={currentBasicOptometryEdit.ejedh}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        ejedh: e,
                      });
                    }}
                    onBlur={(e) => {
                      setCurrentBasicOptometryEdit((prev) => ({
                        ...prev,
                        ejedv:
                          e !== ""
                            ? Number(e) + 90 > 180
                              ? Number(e) - 90
                              : Number(e) + 90
                            : currentBasicOptometryEdit.ejedv,
                      }));
                    }}
                  ></InputData>
                </div>
                <div className="cell cell-label cell-start-content">°</div>
                <div className="cell cell-label">V</div>
                <div className="cell">
                  <InputData
                    tabIndex={93}
                    type="type-float2"
                    size={0}
                    input={currentBasicOptometryEdit.v_od_dp}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        v_od_dp: e,
                      });
                    }}
                    onBlur={(e) => {
                      setCurrentBasicOptometryEdit((prev) => ({
                        ...prev,
                        v_od_mm:
                          e !== ""
                            ? Math.round((337.5 / Number(e)) * 100) / 100
                            : currentBasicOptometryEdit.v_od_mm,
                      }));
                    }}
                  ></InputData>
                </div>
                <div className="cell cell-label cell-start-content">dp</div>
                <div className="cell">
                  <InputData
                    tabIndex={94}
                    type="type-float2"
                    size={0}
                    input={currentBasicOptometryEdit.v_od_mm}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        v_od_mm: e,
                      });
                    }}
                    onBlur={(e) => {
                      setCurrentBasicOptometryEdit((prev) => ({
                        ...prev,
                        v_od_dp:
                          e !== ""
                            ? Math.round((337.5 / Number(e)) * 100) / 100
                            : currentBasicOptometryEdit.v_od_dp,
                      }));
                    }}
                  ></InputData>
                </div>
                <div className="cell cell-label cell-start-content">m/m</div>
                <div className="cell">
                  <InputData
                    tabIndex={95}
                    type="type-only-positive-numbers"
                    maxLength={3}
                    size={0}
                    input={currentBasicOptometryEdit.ejedv}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        ejedv: e,
                      });
                    }}
                    onBlur={(e) => {
                      setCurrentBasicOptometryEdit((prev) => ({
                        ...prev,
                        ejedh:
                          e !== ""
                            ? Number(e) + 90 > 180
                              ? Number(e) - 90
                              : Number(e) + 90
                            : currentBasicOptometryEdit.ejedh,
                      }));
                    }}
                  ></InputData>
                </div>
                <div className="cell cell-label cell-start-content">°</div>
                <div className="cell combined-cells-3"></div>
                <div className="cell cell-label">OI</div>
                <div className="cell combined-cells-3"></div>
                <div className="cell cell-label">H</div>
                <div className="cell">
                  <InputData
                    tabIndex={96}
                    type="type-float2"
                    size={0}
                    input={currentBasicOptometryEdit.h_oi_dp}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        h_oi_dp: e,
                      });
                    }}
                    onBlur={(e) => {
                      setCurrentBasicOptometryEdit((prev) => ({
                        ...prev,
                        h_oi_mm:
                          e !== ""
                            ? Math.round((337.5 / Number(e)) * 100) / 100
                            : currentBasicOptometryEdit.h_oi_mm,
                      }));
                    }}
                  ></InputData>
                </div>
                <div className="cell cell-label cell-start-content">dp</div>
                <div className="cell">
                  <InputData
                    tabIndex={97}
                    type="type-float2"
                    size={0}
                    input={currentBasicOptometryEdit.h_oi_mm}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        h_oi_mm: e,
                      });
                    }}
                    onBlur={(e) => {
                      setCurrentBasicOptometryEdit((prev) => ({
                        ...prev,
                        h_oi_dp:
                          e !== ""
                            ? Math.round((337.5 / Number(e)) * 100) / 100
                            : currentBasicOptometryEdit.h_oi_dp,
                      }));
                    }}
                  ></InputData>
                </div>
                <div className="cell cell-label cell-start-content">m/m</div>
                <div className="cell">
                  <InputData
                    tabIndex={98}
                    type="type-only-positive-numbers"
                    maxLength={3}
                    size={0}
                    input={currentBasicOptometryEdit.ejeih}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        ejeih: e,
                      });
                    }}
                    onBlur={(e) => {
                      setCurrentBasicOptometryEdit((prev) => ({
                        ...prev,
                        ejeiv:
                          e !== ""
                            ? Number(e) + 90 > 180
                              ? Number(e) - 90
                              : Number(e) + 90
                            : currentBasicOptometryEdit.ejeiv,
                      }));
                    }}
                  ></InputData>
                </div>
                <div className="cell cell-label cell-start-content">°</div>
                <div className="cell cell-label">V</div>
                <div className="cell">
                  <InputData
                    tabIndex={99}
                    type="type-float2"
                    size={0}
                    input={currentBasicOptometryEdit.v_oi_dp}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        v_oi_dp: e,
                      });
                    }}
                    onBlur={(e) => {
                      setCurrentBasicOptometryEdit((prev) => ({
                        ...prev,
                        v_oi_mm:
                          e !== ""
                            ? Math.round((337.5 / Number(e)) * 100) / 100
                            : currentBasicOptometryEdit.v_oi_mm,
                      }));
                    }}
                  ></InputData>
                </div>
                <div className="cell cell-label cell-start-content">dp</div>
                <div className="cell">
                  <InputData
                    tabIndex={100}
                    type="type-float2"
                    size={0}
                    input={currentBasicOptometryEdit.v_oi_mm}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        v_oi_mm: e,
                      });
                    }}
                    onBlur={(e) => {
                      setCurrentBasicOptometryEdit((prev) => ({
                        ...prev,
                        v_oi_dp:
                          e !== ""
                            ? Math.round((337.5 / Number(e)) * 100) / 100
                            : currentBasicOptometryEdit.v_oi_dp,
                      }));
                    }}
                  ></InputData>
                </div>
                <div className="cell cell-label cell-start-content">m/m</div>
                <div className="cell">
                  <InputData
                    tabIndex={101}
                    type="type-only-positive-numbers"
                    maxLength={3}
                    size={0}
                    input={currentBasicOptometryEdit.ejeiv}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        ejeiv: e,
                      });
                    }}
                    onBlur={(e) => {
                      setCurrentBasicOptometryEdit((prev) => ({
                        ...prev,
                        ejeih:
                          e !== ""
                            ? Number(e) + 90 > 180
                              ? Number(e) - 90
                              : Number(e) + 90
                            : currentBasicOptometryEdit.ejeih,
                      }));
                    }}
                  ></InputData>
                </div>
                <div className="cell cell-label cell-start-content">°</div>
              </div>
            </div>
            <div
              className="opt-table-container external-container"
              style={{ gridColumn: "4/span 2", gridRow: "3/span 1" }}
            >
              <div className="opt-table-title opt-table-title-grid-7">
                <div className="cell cell-fs-15">Prisma</div>
                <div className="cell combined-cells-6"></div>
                <div className="cell"></div>
              </div>
              <div className="opt-table-content" id="prisma">
                <div className="cell"></div>
                <div className="cell cell-label">Prisma</div>
                <div className="cell cell-label combined-cells-5">Base</div>
                <div className="cell cell-label cell-start-content">OD</div>
                <div className="cell">
                  <InputData
                    tabIndex={81}
                    type="type-positive-float"
                    size={0}
                    maxLength={5}
                    input={currentBasicOptometryEdit.prisma_d}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        prisma_d: e,
                      });
                    }}
                  ></InputData>
                </div>
                <div className="cell combined-cells-3">
                  <Dropdown
                    id="prisma-base-od"
                    tabIndex={82}
                    optionList={BASELIST}
                    size={0}
                    op={currentBasicOptometryEdit.base_d}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        base_d: e.text,
                      });
                    }}
                  ></Dropdown>
                </div>
                <div className="cell">
                  <InputData
                    tabIndex={83}
                    type="type-only-positive-numbers"
                    size={0}
                    maxLength={3}
                    input={currentBasicOptometryEdit.base_d2}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        base_d2: e,
                      });
                    }}
                  ></InputData>
                </div>
                <div className="cell cell-label cell-start-content">°</div>
                <div className="cell cell-label cell-start-content">OI</div>
                <div className="cell">
                  <InputData
                    tabIndex={84}
                    type="type-positive-float"
                    size={0}
                    maxLength={5}
                    input={currentBasicOptometryEdit.prisma_i}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        prisma_i: e,
                      });
                    }}
                  ></InputData>
                </div>
                <div className="cell combined-cells-3">
                  <Dropdown
                    id="prisma-base-oi"
                    tabIndex={85}
                    optionList={BASELIST}
                    size={0}
                    op={currentBasicOptometryEdit.base_i}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        base_i: e.text,
                      });
                    }}
                  ></Dropdown>
                </div>
                <div className="cell">
                  <InputData
                    tabIndex={86}
                    type="type-only-positive-numbers"
                    size={0}
                    maxLength={3}
                    input={currentBasicOptometryEdit.base_i2}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        base_i2: e,
                      });
                    }}
                  ></InputData>
                </div>
                <div className="cell cell-label cell-start-content">°</div>
              </div>
            </div>
            <div
              className="opt-table-container external-container"
              style={{ gridColumn: "6/span 1", gridRow: "3/span 1" }}
            >
              <div className="opt-table-title opt-table-title-grid-2">
                <div className="cell combined-cells-2 cell-fs-15">
                  Tonometría (PIO mmHg)
                </div>
              </div>
              <div className="opt-table-content" id="tonometria">
                <div className="cell combined-cells-2"></div>
                <div className="cell">
                  <InputData
                    tabIndex={87}
                    type="type-positive-float"
                    size={0}
                    input={currentBasicOptometryEdit.pio_d}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        pio_d: e,
                      });
                    }}
                  ></InputData>
                </div>
                <div className="cell cell-label cell-start-content">Hora</div>
                <div className="cell">
                  <InputData
                    tabIndex={88}
                    type="type-positive-float"
                    size={0}
                    input={currentBasicOptometryEdit.pio_i}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        pio_i: e,
                      });
                    }}
                  ></InputData>
                </div>
                <div className="cell">
                  <input
                    type="time"
                    tabIndex={89}
                    className="input-field input-cell"
                    name="hora"
                    min="00:00"
                    max="23:59"
                    step="60"
                    value={currentBasicOptometryEdit.pio_hora}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        pio_hora: e.target.value,
                      });
                    }}
                    onKeyUp={(e) => inputOnEnter(e)}
                  ></input>
                </div>
              </div>
            </div>
            <div
              className="opt-table-container external-container"
              style={{ gridColumn: "1/span 2", gridRow: "4/span 1" }}
            >
              <div
                className="opt-table-title opt-table-title-grid-6"
                id="av"
                style={{ display: "grid" }}
              >
                <div className="cell cell-fs-15">AV</div>
                <div className="cell combined-cells-2 cell-fs-15">SC</div>
                <div className="cell"></div>
                <div className="cell combined-cells-2 cell-fs-15">CC</div>
              </div>
              <div className="opt-table-content" id="av">
                <div className="cell"></div>
                <div className="cell cell-label">VL</div>
                <div className="cell cell-label">VP</div>
                <div className="cell"></div>
                <div className="cell cell-label">VL</div>
                <div className="cell cell-label">VP</div>
                <div className="cell cell-label cell-start-content">OD</div>
                <div className="cell">
                  <InputData
                    tabIndex={63}
                    maxLength={9}
                    type="type-alphanum-ext-2"
                    size={0}
                    input={currentBasicOptometryEdit.av_sc_lejos_d}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        av_sc_lejos_d: e,
                      });
                    }}
                  ></InputData>
                </div>
                <div className="cell">
                  <InputData
                    tabIndex={66}
                    maxLength={9}
                    type="type-alphanum-ext-2"
                    size={0}
                    input={currentBasicOptometryEdit.av_sc_cerca_d}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        av_sc_cerca_d: e,
                      });
                    }}
                  ></InputData>
                </div>
                <div className="cell"></div>
                <div className="cell">
                  <InputData
                    tabIndex={69}
                    maxLength={9}
                    type="type-alphanum-ext-2"
                    size={0}
                    input={currentBasicOptometryEdit.av_cc_lejos_d}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        av_cc_lejos_d: e,
                      });
                    }}
                  ></InputData>
                </div>
                <div className="cell">
                  <InputData
                    tabIndex={72}
                    maxLength={9}
                    type="type-alphanum-ext-2"
                    size={0}
                    input={currentBasicOptometryEdit.av_cc_cerca_d}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        av_cc_cerca_d: e,
                      });
                    }}
                  ></InputData>
                </div>
                <div className="cell cell-label cell-start-content">OI</div>
                <div className="cell">
                  <InputData
                    tabIndex={64}
                    maxLength={9}
                    type="type-alphanum-ext-2"
                    size={0}
                    input={currentBasicOptometryEdit.av_sc_lejos_i}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        av_sc_lejos_i: e,
                      });
                    }}
                  ></InputData>
                </div>
                <div className="cell">
                  <InputData
                    tabIndex={67}
                    maxLength={9}
                    type="type-alphanum-ext-2"
                    size={0}
                    input={currentBasicOptometryEdit.av_sc_cerca_i}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        av_sc_cerca_i: e,
                      });
                    }}
                  ></InputData>
                </div>
                <div className="cell"></div>
                <div className="cell">
                  <InputData
                    tabIndex={70}
                    maxLength={9}
                    type="type-alphanum-ext-2"
                    size={0}
                    input={currentBasicOptometryEdit.av_cc_lejos_i}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        av_cc_lejos_i: e,
                      });
                    }}
                  ></InputData>
                </div>
                <div className="cell">
                  <InputData
                    tabIndex={73}
                    maxLength={9}
                    type="type-alphanum-ext-2"
                    size={0}
                    input={currentBasicOptometryEdit.av_cc_cerca_i}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        av_cc_cerca_i: e,
                      });
                    }}
                  ></InputData>
                </div>
                <div className="cell cell-label cell-start-content">AO</div>
                <div className="cell">
                  <InputData
                    tabIndex={65}
                    maxLength={9}
                    type="type-alphanum-ext-2"
                    size={0}
                    input={currentBasicOptometryEdit.av_sc_lejos}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        av_sc_lejos: e,
                      });
                    }}
                  ></InputData>
                </div>
                <div className="cell">
                  <InputData
                    tabIndex={68}
                    maxLength={9}
                    type="type-alphanum-ext-2"
                    size={0}
                    input={currentBasicOptometryEdit.av_sc_cerca}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        av_sc_cerca: e,
                      });
                    }}
                  ></InputData>
                </div>
                <div className="cell"></div>
                <div className="cell">
                  <InputData
                    tabIndex={71}
                    maxLength={9}
                    type="type-alphanum-ext-2"
                    size={0}
                    input={currentBasicOptometryEdit.av_cc_lejos}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        av_cc_lejos: e,
                      });
                    }}
                  ></InputData>
                </div>
                <div className="cell">
                  <InputData
                    tabIndex={74}
                    maxLength={9}
                    type="type-alphanum-ext-2"
                    size={0}
                    input={currentBasicOptometryEdit.av_cc_cerca}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        av_cc_cerca: e,
                      });
                    }}
                  ></InputData>
                </div>
              </div>
            </div>
            <div
              className="opt-table-container external-container"
              style={{ gridColumn: "3/span 1", gridRow: "4/span 1" }}
            >
              <div className="opt-table-title opt-table-title-grid-4">
                <div className="cell"></div>
                <div className="cell combined-cells-2 cell-fs-15">
                  DIP (Distancia Interpupilar)
                </div>
              </div>
              <div className="opt-table-content" id="dip">
                <div className="cell"></div>
                <div className="cell cell-label">VL</div>
                <div className="cell cell-label">VP</div>
                <div className="cell cell-label cell-start-content">NPD</div>
                <div className="cell">
                  <InputData
                    tabIndex={75}
                    type="type-positive-float"
                    size={0}
                    input={currentBasicOptometryEdit.nasopupilar_lejos_d}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        nasopupilar_lejos_d: e,
                      });
                    }}
                    onBlur={(e) => {
                      const nasopupilar =
                        currentBasicOptometryEdit.nasopupilar_lejos_i;
                      const interpupilar =
                        e === "" && nasopupilar === ""
                          ? ""
                          : Number(e || 0) + Number(nasopupilar || 0);

                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        interpupilar_lejos: interpupilar,
                      });
                    }}
                  ></InputData>
                </div>
                <div className="cell">
                  <InputData
                    tabIndex={78}
                    type="type-positive-float"
                    size={0}
                    input={currentBasicOptometryEdit.nasopupilar_cerca_d}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        nasopupilar_cerca_d: e,
                      });
                    }}
                    onBlur={(e) => {
                      const nasopupilar =
                        currentBasicOptometryEdit.nasopupilar_cerca_i;
                      const interpupilar =
                        e === "" && nasopupilar === ""
                          ? ""
                          : Number(e || 0) + Number(nasopupilar || 0);

                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        interpupilar_cerca: interpupilar,
                      });
                    }}
                  ></InputData>
                </div>
                <div className="cell cell-label cell-start-content">DIP</div>
                <div className="cell">
                  <InputData
                    tabIndex={77}
                    type="type-positive-float"
                    size={0}
                    input={currentBasicOptometryEdit.interpupilar_lejos}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        interpupilar_lejos: e,
                      });
                    }}
                  ></InputData>
                </div>
                <div className="cell">
                  <InputData
                    tabIndex={80}
                    type="type-positive-float"
                    size={0}
                    input={currentBasicOptometryEdit.interpupilar_cerca}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        interpupilar_cerca: e,
                      });
                    }}
                  ></InputData>
                </div>
                <div className="cell cell-label cell-start-content">NPI</div>
                <div className="cell">
                  <InputData
                    tabIndex={76}
                    type="type-positive-float"
                    size={0}
                    input={currentBasicOptometryEdit.nasopupilar_lejos_i}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        nasopupilar_lejos_i: e,
                      });
                    }}
                    onBlur={(e) => {
                      const nasopupilar =
                        currentBasicOptometryEdit.nasopupilar_lejos_d;
                      const interpupilar =
                        e === "" && nasopupilar === ""
                          ? ""
                          : Number(e || 0) + Number(nasopupilar || 0);

                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        interpupilar_lejos: interpupilar,
                      });
                    }}
                  ></InputData>
                </div>
                <div className="cell">
                  <InputData
                    tabIndex={79}
                    type="type-positive-float"
                    size={0}
                    input={currentBasicOptometryEdit.nasopupilar_cerca_i}
                    onChange={(e) => {
                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        nasopupilar_cerca_i: e,
                      });
                    }}
                    onBlur={(e) => {
                      const nasopupilar =
                        currentBasicOptometryEdit.nasopupilar_cerca_d;
                      const interpupilar =
                        e === "" && nasopupilar === ""
                          ? ""
                          : Number(e || 0) + Number(nasopupilar || 0);

                      setCurrentBasicOptometryEdit({
                        ...currentBasicOptometryEdit,
                        interpupilar_cerca: interpupilar,
                      });
                    }}
                  ></InputData>
                </div>
              </div>
            </div>
            <div
              className="opt-table-container external-container"
              style={{ gridColumn: "4/span 2", gridRow: "4/span 1" }}
            >
              <div className="opt-table-title">Esquema</div>
              <button
                className="popup-screen-eye-schema"
                onClick={() => {
                  props.toggleEyeSchema(currentBasicOptometryEdit);
                }}
              >
                <img
                  src="/images/eye-dark.svg"
                  loading="lazy"
                  alt="Icon"
                  className="eye-schema-icon"
                ></img>
                <img
                  src="/images/eye-dark.svg"
                  loading="lazy"
                  alt="Icon"
                  className="eye-schema-icon"
                ></img>
                <div className="canvas-container">
                  <CanvasDraw
                    ref={canvasRef}
                    lazyRadius={0}
                    canvasWidth={225}
                    canvasHeight={150}
                    hideGrid={true}
                    hideInterface={false}
                    onChange={() => {}}
                    disabled={true}
                    style={{
                      background: "transparent",
                    }}
                    canvasBackgroundColor="rgba(0, 0, 0, 0)"
                  />
                </div>
              </button>
            </div>
            <div
              className="opt-table-container external-container"
              style={{ gridColumn: "6/span 1", gridRow: "4/span 1" }}
            >
              <div className="opt-table-title">Observaciones</div>
              <div className="section-content-data section-content-data-obs">
                <span className="section-content-message">
                  <span className="obs-text">
                    {optometryId !== -1 ? props.numObservations : 0}
                    &nbsp;observaciones&nbsp;
                  </span>
                </span>
                <div className="section-content-buttons">
                  <ButtonIconH
                    text="Abrir"
                    small={true}
                    onClick={() => {
                      if (optometryId !== -1) {
                        props.toggleObservationsPanel(
                          true,
                          currentBasicOptometryEdit.idOptometria,
                        );
                      } else {
                        props.createPopupQuestion(
                          "Por favor, guarde la ficha que está creando antes de abrir el panel de observaciones.",
                          async () => {
                            props.removePopupQuestion();
                          },
                          null,
                          "Entendido",
                        );
                      }
                    }}
                  ></ButtonIconH>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
